var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnDeletePorfolioEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 11,
    fill: "#ECEDEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0488 12.0498L20.1488 20.1498",
    stroke: "#555555",
    strokeWidth: 1.215,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1504 12.0498L12.0504 20.1498",
    stroke: "#555555",
    strokeWidth: 1.215,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDeletePorfolioEllipse);
export default __webpack_public_path__ + "static/media/btn_delete_porfolio_ellipse.88c508c75c7323e4f6c134b0d54d2c27.svg";
export { ForwardRef as ReactComponent };